module.exports = __webpack_public_path__ + "static/media/requestsSelected.1b887985.svg";